import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl } from 'react-intl';
import { CogAlternate } from '@bibliocommons/deprecated-base-icons';
import { Shelves } from '@bibliocommons/base-icons';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import './OnShelfButton.scss';

class OnShelfButton extends React.PureComponent {
  render() {
    const { shelfItem, intl, disabled } = this.props;
    const name = shelfItem.get('shelf');
    const formattedShelfName = intl.formatMessage({
      id: `label_shelf_${name}`
    });
    const privateItem = shelfItem.get('privateItem');

    return (
      <DefaultButton
        className="cp-on-shelf-button"
        disabled={disabled}
        handleClick={() => this.props.handleClick()}
        aria-label={intl.formatMessage({ id: 'item_on_shelf_cta' }, { shelfName: formattedShelfName })}
        tagName="button"
        href="#add-to-shelf"
      >
        <div className="shelf-button-flex-wrap">
          <Shelves isPrivate={privateItem} onShelf />
          <span className="shelf-name-text">{formattedShelfName}</span>
        </div>
        <div className="cog-wrap">
          <CogAlternate color="#666" width={14} height={14} />
        </div>
      </DefaultButton>
    );
  }
}

const injectIntlPropTypes = {};

OnShelfButton.propTypes = {
  shelfItem: ImmutablePropTypes.map,
  handleClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  ...injectIntlPropTypes
};

export default injectIntl(OnShelfButton);
